export default "__VITE_ASSET__DAtPWECK__"